import api from './axios';

export const getVinculos = () =>
  api.get('/vinculos').then((r) => r.data);

export const createVinculo = (data) =>
  api.post('/vinculos', data).then((r) => r.data);

export const updateVinculo = (id, data) =>
  api.patch(`/vinculos/${id}`, data).then((r) => r.data);

export const getHistoricoSetor = (id) =>
  api.get(`/vinculos/${id}/historico-setor`).then((r) => r.data);

export const getHistoricoFuncao = (id) =>
  api.get(`/vinculos/${id}/historico-funcao`).then((r) => r.data);
